export const isProductLinkActionable = (link, { isMaster = false } = {}) => {
  if (isMaster || link?.type === 'master') return true;
  if (link?.type === 'listing') return Boolean(link.masterProductId);
  if (link?.masterProductId) return true;
  if (link?.salesChannelId || link?.salesChannel) return false;
  return Boolean(link?._id);
};

export const isVariantLinkActionable = (link) => {
  if (link?.type === 'masterVariant') return true;
  if (link?.type === 'listingVariant') {
    return Boolean(link.masterProductId && link.masterVariantId);
  }
  return Boolean(link?.masterProductId && link?.masterVariantId);
};
